import { type BaseTag } from '@hungryroot/rest';
import { tags } from '@hungryroot/tags';

export const exclusionTagMap = {
  meat: [tags.BeefAndBison, tags.Poultry],
  seafood: [tags.FreshFish],
  plantBased: [],
  cuisine: [],
  flavors: [],
  dislikes: [tags.Onions, tags.Garlic],
} as const;

type TagGroup = keyof typeof exclusionTagMap;

type TagFilter = (tag: BaseTag) => boolean;

export function useFilteredQuizTags() {
  const getDisplayTagsFilter = (group: TagGroup): TagFilter => {
    const tags: readonly number[] = exclusionTagMap[group];

    return (tag) => !tags.includes(tag.id);
  };

  return {
    getDisplayTagsFilter,
  };
}
